export default [
  require("/home/runner/work/reactodia.github.io/reactodia.github.io/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/reactodia.github.io/reactodia.github.io/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/reactodia.github.io/reactodia.github.io/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/reactodia.github.io/reactodia.github.io/src/css/custom.css"),
];
